export const formFieldWrapperClasses = {
    root: "formfield-root",
    container: "formfield-container",
    desktopLabel: "formfield-desktopLabel",
    extendedBorder: "formfield-extendedBorder",
    requiredIcon: "formfield-requiredIcon",
    errorIcon: "formfield-errorIcon",
    validationText: "formfield-validationText",
    iconContainer: "formfield-iconContainer"
};
export function getFormFieldStyles({ error, isMobile, label, disabled, warning, labelWidth, labelPosition }) {
    return ({ breakpoints, palette }) => ({
        [`& .${formFieldWrapperClasses.root}`]: {
            width: "100%",
            display: "flex",
            justifyContent: "stretch",
            alignItems: "baseline",
            [breakpoints.down("sm")]: {
                minWidth: "100%"
            }
        },
        [`& .${formFieldWrapperClasses.container}`]: {
            width: "100%",
            display: "flex",
            flexDirection: labelPosition == "left" ? "row" : "column",
            alignItems: labelPosition == "left" ? "flex-end" : "flex-start",
            height: "inherit",
            backgroundColor: labelPosition == "left" ? palette.common.white : "transparent",
            [breakpoints.down("sm")]: {
                flexDirection: "column",
                alignItems: "flex-start",
                backgroundColor: "transparent"
            }
        },
        [`& .${formFieldWrapperClasses.desktopLabel}`]: {
            display: "inline-block",
            alignSelf: "flex-start",
            paddingRight: "5px",
            paddingLeft: "5px",
            width: "100%",
            maxWidth: label && labelWidth,
            //A margin needs to be added so it matches the height of the input element when it is positioned beside it.
            marginTop: "7px",
            height: "inherit",
            "&::after": {
                content: '":"'
            }
        },
        [`& .${formFieldWrapperClasses.extendedBorder}`]: {
            color: palette.controls.input.border.main,
            width: "100%",
            borderBottom: disabled
                ? `solid 1px ${palette.controls.input.border.main}`
                : error
                    ? `1px solid ${palette.error.main}`
                    : warning
                        ? `1px solid ${palette.warning.main}`
                        : `solid 1px ${palette.controls.input.border.main}`,
            "&:hover": {
                borderBottom: disabled || warning || error ? `auto` : `1px solid ${palette.controls.input.border.hover}`
            },
            "&:focus": {
                backgroundColor: "red"
            },
            "&:focus-within": {
                borderBottom: disabled || warning || error ? `auto` : `1px solid ${palette.controls.input.border.focus}`,
                color: palette.controls.input.border.focus
            }
        },
        [`& .${formFieldWrapperClasses.requiredIcon}`]: {
            color: palette.warning.main,
            left: 0
        },
        [`& .${formFieldWrapperClasses.errorIcon}`]: {
            color: palette.error.main
        },
        [`& .${formFieldWrapperClasses.validationText}`]: {
            maxWidth: "inherit",
            display: "block",
            color: error ? palette.error.main : palette.warning.main,
            fontSize: 10,
            paddingLeft: "1rem",
            [breakpoints.down("sm")]: {
                minWidth: "100%"
            }
        },
        [`& .${formFieldWrapperClasses.iconContainer}`]: {
            position: "relative",
            minWidth: "0.5em",
            maxWidth: "0.5em",
            marginTop: label && isMobile && "1em",
            marginRight: "2px",
            fontSize: 20,
            alignSelf: "top"
        }
    });
}
